import { render, staticRenderFns } from "./MultiFileUpload2.vue?vue&type=template&id=62701646&scoped=true"
import script from "./MultiFileUpload2.vue?vue&type=script&lang=js"
export * from "./MultiFileUpload2.vue?vue&type=script&lang=js"
import style0 from "./MultiFileUpload2.vue?vue&type=style&index=0&id=62701646&prod&scoped=true&lang=css"
import style1 from "./MultiFileUpload2.vue?vue&type=style&index=1&id=62701646&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62701646",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCardActions,VCardText,VDialog})
